GP.vent.on("init_js:user:edit_user_profile", function(self) {
    var original_bio_text = $('#t6').val().trim();
    var about_max_length = (typeof _about_me_max_length != 'undefined') ? _about_me_max_length : 2000;

    $('#t6, #t7').on('keyup', function() {
        var $text_area = $(this);
        GP.Util.count_chars($text_area, $('#'+$text_area.data('target-id')), about_max_length);
        original_bio_text = $text_area.val().trim();
    });
    $('#t6, #t7').on('paste', function() {
        var $text_area = $(this);

        // timeout fixes iOS reading textarea value.
        setTimeout(function() {
            GP.Util.count_chars($text_area, $('#'+$text_area.data('target-id')), about_max_length);
            original_bio_text = $text_area.val().trim();
        }, 300);
    });
    $('#height_cm').on('change', function() {
        var height_cm = parseInt($(this).val(),10) || 0;
        var height_ft = Math.floor(height_cm/2.5/12);
        var height_in = Math.round(height_cm/2.5 - height_ft*12);
        $('#height_ft').val(height_ft);
        $('#height_in').val(height_in);
    });
    $('#height_in, #height_ft').on('change', function() {
        var height_ft = parseInt($('#height_ft').val(),10) || 0;
        var height_in = parseInt($('#height_in').val(),10) || 0;
        var height_cm = Math.round((height_ft*12+height_in)*2.5);
        $('#height_cm').val(height_cm);
    });

    $('#country_code').change(function() {
        $('#location_id, #city_name').val('');
        var country_code = $(this).find('option:selected').val();
        if (country_code == 'US') {
            $('.loc_label').text(location_zip);
        } else {
            $('.loc_label').text(location_city);
        }
    });

    var _picker_row_size = GP.sdata.is_mobile ? 5 : 10;
    $('#edit-games-interest-select').selectpicker({
        maxOptions: 3,
        size:       _picker_row_size,
        liveSearch: true,
        dropupAuto: false
    });

    let interest_count = 0;
    self.update_interests_total_text = function() {
        $('#form-group-interests .text-count-current').text(interest_count);
    };    
    self.update_interests_total = function() {
        $('#form-group-interests input[name="interests[]"]').each(function() {
            if ($(this).is(':checked')) {
                interest_count = interest_count + 1;
                self.update_interests_total_text();
            }
        });
    };

    self.update_interests_total();

    $('#form-group-interests input[name="interests[]"]').on('change', function(e) {
        if ($(this).val() === 'GAMES' && $(this).is(':checked')) {
            $('#form-group-games').addClass('shown');
        }

        if  ($(this).val() === 'GAMES' && !$(this).is(':checked')) {
            $('#form-group-games').removeClass('shown');
        }

        if (interest_count === _user_interests_max) {
            if ($(this).is(':checked')) {
                $(this).prop("checked", false);
            } else {
                interest_count = interest_count - 1;
                self.update_interests_total_text();
            }

        } else if (interest_count < _user_interests_max) {
            interest_count = $(this).is(':checked') ? interest_count + 1 : interest_count - 1;
            self.update_interests_total_text();
        }
    });

    // handle search filter
    $('#form-group-interests .input-search-interests').on('keyup', function(e) {
        let filter_text = $(this).val().toLowerCase();

        $('.checkbox-pill-wrap').each(function() {
            let $checkbox_val = String($(this).data('value'));
            if ($checkbox_val.indexOf(filter_text) > -1) {
                $(this).css('display', 'inline-block');
            } else {
                $(this).css('display', 'none');
            }
        });
    });



    $('#assistant-suggest .suggest-wand').on('click', function(e) {
        var bio_text = $('#t6').val().trim();

        if (bio_text && bio_text.length >= 50) {
            var $wand = $(this);
            var $spinner = $('#assistant-suggest').find('.suggest-spinner');
            var $undo = $('#assistant-suggest').find('.suggest-undo');
            $wand.addClass('gp-hidden');
            $spinner.removeClass('gp-hidden');
            $undo.addClass('gp-hidden');

            $.post('/members/msg/get_suggestion/', { 'suggest_type': 'bio', 'seed_bio': bio_text })
                .success(function(result) {
                    if (result.suggestion) {
                        $('#t6').val(result.suggestion);
                        $undo.removeClass('gp-hidden');
                    } else if (result.limits_reached)  {
                        GP.vent.trigger('Modal:open:confirm', { template: 'AI_LIMIT_REACHED' });
                    } else {
                        alert('Oops, something went wrong.');
                    }
                }).fail(function() {
                    alert('Oops, something went wrong.');
                    //self.show_notification('danger', 'Oops, something went wrong.');
                }).always(function() {
                    $wand.removeClass('gp-hidden');
                    $spinner.addClass('gp-hidden');
                });
        } else {
            GP.vent.trigger('Modal:open', {url: '/members/modals/get_bio_suggest_intro/'});
        }
    });

    $('#assistant-suggest .suggest-undo').on('click', function(e) {
        var current_bio_text = $('#t6').val().trim();
        if (original_bio_text.length && original_bio_text != current_bio_text) {
            $('#t6').val(original_bio_text);
        }
        $(this).addClass('gp-hidden');
    });

});
